import { Buffergs925ekssbch as Buffer } from './Buffer.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { EOFExceptionh831u25jcq9n as EOFException } from './-PlatformJs.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
  add2suhfggl4zvkk as add,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { checkBoundsw7d8y6z7j2xc as checkBounds } from './-Util.mjs';
import { PeekSource3frbthc9yehpr as PeekSource } from './PeekSource.mjs';
import { buffered3kq86cdmguv3h as buffered } from './Core.mjs';
import { Source1shr0ps16u4p4 as Source } from './Source.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var RealSourceClass;
function RealSource() {
  if (RealSourceClass === VOID) {
    class $ {
      constructor(source) {
        this.l4k_1 = source;
        this.m4k_1 = false;
        this.n4k_1 = new (Buffer())();
      }
      r3y() {
        return this.n4k_1;
      }
      h4j(sink, byteCount) {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.m4k_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().o(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message_0 = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().o2(toString(message_0));
        }
        if (this.n4k_1.q2() === 0n) {
          var read = this.l4k_1.h4j(this.n4k_1, 8192n);
          if (read === -1n)
            return -1n;
        }
        // Inline function 'kotlin.comparisons.minOf' call
        var b = this.n4k_1.q2();
        var toRead = byteCount <= b ? byteCount : b;
        return this.n4k_1.h4j(sink, toRead);
      }
      s3y() {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.m4k_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().o(toString(message));
        }
        return this.n4k_1.s3y() && this.l4k_1.h4j(this.n4k_1, 8192n) === -1n;
      }
      t3y(byteCount) {
        if (!this.y3y(byteCount))
          throw EOFException().m4i("Source doesn't contain required number of bytes (" + byteCount.toString() + ').');
      }
      y3y(byteCount) {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.m4k_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().o(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message_0 = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().o2(toString(message_0));
        }
        while (this.n4k_1.q2() < byteCount) {
          if (this.l4k_1.h4j(this.n4k_1, 8192n) === -1n)
            return false;
        }
        return true;
      }
      b3z() {
        this.t3y(1n);
        return this.n4k_1.b3z();
      }
      f4j(sink, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = sink.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        if (this.n4k_1.q2() === 0n) {
          var read = this.l4k_1.h4j(this.n4k_1, 8192n);
          if (read === -1n)
            return -1;
        }
        var tmp0 = endIndex - startIndex | 0;
        // Inline function 'kotlinx.io.minOf' call
        var b = this.n4k_1.q2();
        // Inline function 'kotlin.comparisons.minOf' call
        var a = fromInt(tmp0);
        var tmp$ret$1 = a <= b ? a : b;
        var toRead = convertToInt(tmp$ret$1);
        return this.n4k_1.f4j(sink, startIndex, startIndex + toRead | 0);
      }
      j4j(sink, byteCount) {
        try {
          this.t3y(byteCount);
        } catch ($p) {
          if ($p instanceof EOFException()) {
            var e = $p;
            sink.i4j(this.n4k_1, this.n4k_1.q2());
            throw e;
          } else {
            throw $p;
          }
        }
        this.n4k_1.j4j(sink, byteCount);
      }
      k4j(sink) {
        var totalBytesWritten = 0n;
        while (!(this.l4k_1.h4j(this.n4k_1, 8192n) === -1n)) {
          var emitByteCount = this.n4k_1.d4j();
          if (emitByteCount > 0n) {
            totalBytesWritten = add(totalBytesWritten, emitByteCount);
            sink.i4j(this.n4k_1, emitByteCount);
          }
        }
        if (this.n4k_1.q2() > 0n) {
          totalBytesWritten = add(totalBytesWritten, this.n4k_1.q2());
          sink.i4j(this.n4k_1, this.n4k_1.q2());
        }
        return totalBytesWritten;
      }
      w4i() {
        this.t3y(2n);
        return this.n4k_1.w4i();
      }
      t40() {
        // Inline function 'kotlinx.io.RealSource.checkNotClosed' call
        // Inline function 'kotlin.check' call
        if (!!this.m4k_1) {
          var message = 'Source is closed.';
          throw IllegalStateException().o(toString(message));
        }
        return buffered(new (PeekSource())(this));
      }
      m6() {
        if (this.m4k_1)
          return Unit_instance;
        this.m4k_1 = true;
        this.l4k_1.m6();
        this.n4k_1.y4();
      }
      toString() {
        return 'buffered(' + toString(this.l4k_1) + ')';
      }
    }
    initMetadataForClass($, 'RealSource', VOID, VOID, [Source()]);
    RealSourceClass = $;
  }
  return RealSourceClass;
}
//region block: exports
export {
  RealSource as RealSource1sojixeyllf40,
};
//endregion

//# sourceMappingURL=RealSource.mjs.map
